import i18next from "i18next";
import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";

const PasswordModal = ({ onConfirm, onCancel }) => {
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const inputRef = useRef(null);
  const { t } = useTranslation();
  const isRtl = i18next.dir() === "rtl";


  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  }, []);

  const handleKeyPress = (e) => {
    if (e.key === "Enter" && password?.length > 0) {
      onConfirm(password);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === "Escape") {
      onCancel();
    }
  };

  const togglePasswordVisibility = () => {
    setShowPassword((prev) => !prev);
  };

  return (
    <div className="fixed top-0 left-0 w-full h-full flex justify-center items-center z-50 backdrop-blur-md drop-shadow-sm">
      <div className="fixed top-0 left-0 w-full h-full bg-black opacity-50 z-40"></div>
      <form
        autoComplete="off"
        className="relative flex flex-col px-6 py-6 text-lg font-semibold leading-6 bg-white rounded-2xl text-zinc-800 max-md:px-5 z-50"
        style={{ width: "450px" }}
      >
        <header className="flex gap-5 text-xl max-md:flex-wrap max-md:max-w-full">
          <h1 className="flex-auto my-auto">{t("Enter Password")}</h1>
          <button
            type="button"
            onClick={onCancel}
            className="absolute top-4 right-3 text-zinc-800"
          >
            {/* Close Icon */}
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="w-6 h-6"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        </header>

        {/* Password input field */}
<div className="relative text-base flex border border-solid rounded-lg overflow-hidden items-center mt-4">
          {/* Dummy hidden input to trick browser autofill */}
          <input type="text" style={{ display: "none" }} aria-hidden="true" />
          <input
            ref={inputRef}
            type={showPassword ? 'text' : 'password'}
            placeholder={t("XXXXXXXX")}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            onKeyPress={handleKeyPress}
            onKeyDown={handleKeyDown}
            autoComplete="new-password" 
            readOnly 
            onFocus={(e) => e.target.removeAttribute("readonly")} 
          className={`p-2 rounded-lg border-0 text-base border-neutral-400 border-opacity-50 text-black w-full focus:outline-none pr-10 ${
  showPassword ? "" : "password-mask"
}`}
            // className="p-3 rounded-xl border-0 border-neutral-400 border-opacity-50 text-black w-full focus:outline-none focus:border-1px pr-12"
          />
          <button
            type="button"
            onClick={togglePasswordVisibility}
            // className="absolute right-4 top-1/2 transform -translate-y-1/2 text-gray-500"
            className={`absolute top-1/2 transform -translate-y-1/2 text-gray-500 ${isRtl ? "left-4" : "right-4"}`}
          >
            {showPassword ? (
              /* Eye Open Icon */
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="w-6 h-6"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                />
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
                />
              </svg>
            ) : (
              /* Eye Closed Icon */
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="w-6 h-6"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.542-7a10.056 10.056 0 012.472-4.49M6.878 6.878A9.956 9.956 0 0112 5c4.478 0 8.268 2.943 9.542 7a9.958 9.958 0 01-4.107 5.042M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                />
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M3 3l18 18"
                />
              </svg>
            )}
          </button>
        </div>

        {/* Confirm and Cancel buttons */}
        <div className="flex justify-end gap-5">
          <button
            type="button"
            onClick={onCancel}
            className="justify-center items-center  px-4 py-1 mt-10 text-base text-center text-primaryBlue rounded-lg border-2 border-primaryBlue border-solid capitalize whitespace-nowrap bg-white max-md:px-5 max-md:mt-10 max-md:max-w-full"
          >
            {t("Cancel")}
          </button>
          <button
            type="button"
            onClick={() => onConfirm(password)}
            disabled={password?.length === 0}
            className={`justify-center items-center px-4 py-1 mt-10 text-base text-center text-white capitalize whitespace-nowrap bg-primaryBlue rounded-lg max-md:px-5 max-md:mt-10 max-md:max-w-full ${
              password?.length === 0 ? "opacity-50 cursor-not-allowed" : ""
            }`}
          >
            {t("Confirm")}
          </button>
        </div>
      </form>
    </div>
  );
};

export default PasswordModal;
